import { app, auth, provider, signInWithPopup, db } from '../firebase/firebase.utils';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { doc, getDoc, getDocs, collection, onSnapshot, addDoc, setDoc, deleteDoc, query, where, orderBy, limit, startAfter } from "firebase/firestore";
import {
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword, sendPasswordResetEmail
} from 'firebase/auth';

export const increment = () => ({
    type: 'counter/increment',
});

export const clearUserDetails = () => ({
    type: 'trevor/clearUserDetails',
    payload: {}
});

export const decrement = () => ({
    type: 'counter/decrement',
});

export const setTargetFundraisingAction = (id) => ({
    type: 'user/userSelectedFundraisingTarget',
    payload: id
});


export const setUserEmail = (email) => ({
    type: 'user/setUserEmail',
    payload: email
});


export const setUserDetails = (userDetails) => {
    return async (dispatch) => {
        console.log('Inside Dispatch of user details', userDetails)
        dispatch({
            type: 'trevor/setUserDetails',
            payload: userDetails
        });
        //console.log('Now getting URL for user dashboard')
        //dispatch(getURLFromTrevorForUserDetails());
    }
}



    ;

export const listenForAuthChanges = () => {
    console.log('listening for auth changes')
    return (dispatch) => {
        auth.onAuthStateChanged(async auth => {
            console.log('auth', auth)
            if (auth) {

                const loggedInUser = { uid: auth.uid, displayName: auth.displayName, email: auth.email };
                console.log('User trying to log in', loggedInUser);
                const docRef = doc(db, "allowedUsers", loggedInUser.email);
                const docSnap = await getDoc(docRef);

                if (docSnap.exists()) {
                    console.log('User is in allowedUsers collection')
                    dispatch({
                        type: 'user/signIn',
                        payload: loggedInUser
                    });
                } else {
                    console.log('User is not in allowedUsers collection');
                    dispatch(signOut());
                }








            } else {
                console.log('User is NOT signed in');
                dispatch({
                    type: 'user/signOut'
                });
            }
        });
    };
};

export const fetchAllowedUsers = (tenantId) => {
    return async (dispatch) => {
        try {
            const querySnapshot = await getDocs(collection(db, "allowedUsers"));
            const users = [];

            querySnapshot.forEach((doc) => {
                const userData = doc.data();

                users.push({
                    id: doc.id,
                    email: doc.id, // email is the document ID
                    role: userData.role,
                    tenantID: userData.tenantID
                });

            });

            dispatch({
                type: 'tenant/setAllowedUsers',
                payload: users
            });

            return users;
        } catch (error) {
            console.error("Error fetching allowed users:", error);
            return [];
        }
    };
};

export const signInWithGoogle = (callback) => {
    return (dispatch) => {
        console.log('Clicked Sign In with Google');
        signInWithPopup(auth, provider)
            .then(async (result) => {
                console.log('User is signed in with Google', result.user);
                const user = result.user;
                const loggedInUser = { uid: user.uid, displayName: user.displayName, email: user.email };
                const docRef = doc(db, "allowedUsers", loggedInUser.email);
                const docSnap = await getDoc(docRef);

                if (docSnap.exists()) {
                    console.log('User is in allowedUsers collection');
                    dispatch({
                        type: 'user/signIn',
                        payload: loggedInUser, // Dispatch only serializable data
                    });
                    if (callback) callback();  // Execute callback if provided
                } else {
                    console.log('User is not in allowedUsers collection');
                    dispatch(signOut());
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };
};

export const signOut = () => {
    return (dispatch) => {
        localStorage.removeItem('logoURL');
        auth.signOut().then(() => {
            dispatch({
                type: 'user/signOut'
            });
        });
    };
}



export const processPOSPaymentAction = (details) => {

    const amount = parseFloat(details.amount.replace(/[$,]/g, ''));
    const email = details.email ? details.email : 'pos@infq.cc';
    const campaign_id = details.targetID;
    const isCause = details.isCause;
    console.log('Sending Payment of $', details.amount, ' to POS for donor:', details.email, ' for target:', campaign_id);





    return async (dispatch, getState) => {
        dispatch({
            type: 'user/setAwaitingPOSResponse',
            payload: true
        });
        const state = getState();
        const functions = getFunctions();

        const processPOSPayment = httpsCallable(functions, 'processPOSPaymentConnectUpdatedV2');
        // let clientAccountId = 'acct_1P3FQzK1meoYW4sX';
        // let terminalId = 'tmr_Fk1nzwB6LxeKIH';
        // let org_id = 'JHfoMzPFPGEfMLc6N2qo';
        let clientAccountId = '';
        let terminalId = '';
        let org_id = '';
        const tenant_id = state.userTenant;
        const docRef = doc(db, "tenants", tenant_id);
        const docSnap = await getDoc(docRef);
        const location_id = state.readers[0].location;


        if (docSnap.exists()) {
            console.log('Found tenant info in Firestore:', docSnap.data());
            clientAccountId = docSnap.data().clientAccountId;

            org_id = docSnap.data().org_id;
        } else {
            return { status: "Error", message: "Tenant info not found in Firestore" };
        }
        terminalId = state.readers[0].id;

        console.log('Calling POS Payment with', { email: email, amount: amount, clientAccountId: clientAccountId, terminalId: terminalId, org_id: org_id, campaign_id: campaign_id, tenant_id: tenant_id, isCause: isCause })

        try {
            const result = await processPOSPayment(
                {
                    email: email, amount: amount,
                    clientAccountId: clientAccountId,
                    terminalId: terminalId, org_id: org_id,
                    campaign_id: campaign_id,
                    tenant_id: tenant_id,
                    location_id: location_id,
                    isCause: isCause
                });
            console.log(result.data);
            dispatch({
                type: 'user/setPOSResponse',
                payload: result.data
            });

            if (result.data.status === "Payment succeeded") {
                dispatch({
                    type: 'payment/setSuccess',
                    payload: {
                        status: result.data.status,
                        amount: result.data.paymentIntent.amount / 100, // Convert cents to dollars
                        email: result.data.paymentIntent.metadata.receipt_email
                    }
                });
            }
        } catch (error) {
            console.error('Error calling stripe:', error);
        }
    };
};

export const cancelPOSPaymentAction = (amount) => {
    console.log('Cancelling Payment POS')

    return async (dispatch, getState) => {
        const state = getState();


        let terminalId = '';

        const tenant_id = state.userTenant;
        const docRef = doc(db, "tenants", tenant_id);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            console.log('Found tenant info in Firestore:', docSnap.data());
            terminalId = docSnap.data().terminalId;
        } else {
            return { status: "Error", message: "Tenant info not found in Firestore" };
        }
        const functions = getFunctions();
        const cancelPOSPayment = httpsCallable(functions, 'cancelPOSPaymentConnect');

        try {
            const clientAccountId = state.clientAccountId;
            const terminalId = state.readers[0].id;
            const result = await cancelPOSPayment({ clientAccountId: clientAccountId, terminalId: terminalId });
            console.log('Result from cancel POS')
            console.log(result.data);
            dispatch({
                type: 'user/setAwaitingPOSResponse',
                payload: false
            });
        } catch (error) {
            console.error('Error calling stripe cancel POS:', error);
        }
    };
};

export const cancelReaderAction = (tenantId, readerId) => {
    return async (dispatch) => {
        try {
            const docRef = doc(db, "tenants", tenantId);
            const docSnap = await getDoc(docRef);

            if (!docSnap.exists()) {
                return { success: false, error: "Tenant not found" };
            }

            const clientAccountId = docSnap.data().clientAccountId;
            if (!clientAccountId) {
                return { success: false, error: "No connected Stripe account found for this tenant" };
            }

            const functions = getFunctions();
            const cancelPOSPayment = httpsCallable(functions, 'cancelPOSPaymentConnect');
            const result = await cancelPOSPayment({ clientAccountId, terminalId: readerId });

            if (result.data?.readerResponse) {
                return { success: true };
            } else {
                return { success: false, error: result.data?.error || 'Failed to cancel reader action' };
            }
        } catch (error) {
            console.error('Error cancelling reader action:', error);
            return { success: false, error: error.message };
        }
    };
};

function reorderTargets(targets) {
    // Find the position of the "General" target
    const generalPosition = targets.findIndex(target => target.name === "General");

    // If "General" is found, remove it from its current position
    const generalTarget = generalPosition !== -1 ? targets.splice(generalPosition, 1)[0] : null;

    // Sort the targets in alphabetical order
    targets.sort((a, b) => a.name.localeCompare(b.name));

    // If "General" was found, add it back at the beginning
    if (generalTarget) {
        targets.unshift(generalTarget);
    }

    return targets;
}


export const fetchReadersForConnectedAccount = (clientAccountId) => {
    return async (dispatch, getState) => {

        const functions = getFunctions();
        const getReadersForConnectedAccount = httpsCallable(functions, 'getReadersForConnectedAccount');
        const result = await getReadersForConnectedAccount({ clientAccountId: clientAccountId });
        dispatch({ type: 'user/setReaders', payload: result.data.readers?.data });
        const readersArray = result.data.readers?.data;
        const myReader = readersArray.find(reader => reader.label === 'Infaque Reader');
        if (myReader && myReader.status === 'online') {
            dispatch({ type: 'user/setReaderStatus', payload: 'online' });
        } else {
            dispatch({ type: 'user/setReaderStatus', payload: 'offline' });
        }
    };
}

export const listLocationsForConnectedAccount = (connectedAccountID, tenantId = null) => {
    return async (dispatch, getState) => {
        try {
            const functions = getFunctions();
            const listLocations = httpsCallable(functions, 'listLocationsForConnectedAccount');
            const result = await listLocations({ connectedAccountID: connectedAccountID });
            
            if (result.data.status === 'Success') {
                const locations = result.data.locations || [];
                console.log(`Fetched ${locations.length} location(s) for tenant: ${tenantId}`);
                
                // If there's one or more locations and tenantId is provided, update locationsCreated to true
                if (locations.length >= 1 && tenantId) {
                    try {
                        console.log(`Setting locationsCreated to true for tenant: ${tenantId} (found ${locations.length} location(s))`);
                        const tenantRef = doc(db, "tenants", tenantId);
                        await setDoc(tenantRef, { locationsCreated: true }, { merge: true });
                        console.log(`Successfully updated locationsCreated to true for tenant: ${tenantId}`);
                        // Refresh tenants list
                        dispatch(fetchTenants());
                    } catch (updateError) {
                        console.error("Error updating locationsCreated:", updateError);
                    }
                } else {
                    if (!tenantId) {
                        console.log("Skipping locationsCreated update: tenantId not provided");
                    } else if (locations.length === 0) {
                        console.log("Skipping locationsCreated update: no locations found");
                    }
                }
                
                return {
                    success: true,
                    locations: locations
                };
            } else {
                return {
                    success: false,
                    error: result.data.error || 'Failed to fetch locations'
                };
            }
        } catch (error) {
            console.error("Error fetching locations:", error);
            return {
                success: false,
                error: error.message || 'Failed to fetch locations'
            };
        }
    };
}

export const calculateFees = (tenantId, amount) => {
    return async (dispatch, getState) => {
        try {
            const functions = getFunctions();
            const calculateFeesFunction = httpsCallable(functions, 'calculateFees');
            const result = await calculateFeesFunction({ 
                tenantId: tenantId, 
                amount: amount 
            });

            if (result.data.status === 'Success') {
                return {
                    success: true,
                    currency: result.data.currency,
                    fees: result.data.fees,
                    band: result.data.band,
                    amount: result.data.amount
                };
            } else {
                return {
                    success: false,
                    error: result.data.error || 'Failed to calculate fees'
                };
            }
        } catch (error) {
            console.error("Error calculating fees:", error);
            return {
                success: false,
                error: error.message || 'Failed to calculate fees'
            };
        }
    };
};

export const createLocationForConnectedAccount = (connectedAccountID, display_name, address) => {
    return async (dispatch, getState) => {
        try {
            const functions = getFunctions();
            const createLocation = httpsCallable(functions, 'createLocationForConnectedAccount');
            const result = await createLocation({ 
                connectedAccountID: connectedAccountID,
                display_name: display_name,
                address: address
            });
            
            if (result.data.status === 'Success') {
                return {
                    success: true,
                    location: result.data.location,
                    message: 'Location created successfully'
                };
            } else {
                return {
                    success: false,
                    error: result.data.error || result.data.message || 'Failed to create location'
                };
            }
        } catch (error) {
            console.error("Error creating location:", error);
            return {
                success: false,
                error: error.message || 'Failed to create location'
            };
        }
    };
}

export const fetchTenantID = () => {
    return async (dispatch, getState) => {
        console.log('Fetching Tenant ID');
        const state = getState();
        const userDetails = state.userDetails;
        const email = userDetails.email;

        console.log('Fetching Tenant ID for ', email)
        const docRef = doc(db, "allowedUsers", email);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            console.log("Document data:", docSnap.data());
            console.log('Setting Tenant ID in Redux:', docSnap.data().tenantID)
            const userRole = docSnap.data().role;
            let tenantID = docSnap.data().tenantID;
            
            // Default to 'infaque' if tenantID is missing, null, or empty
            if (!tenantID) {
                console.log('TenantID is missing, defaulting to "infaque"');
                tenantID = 'infaque';
                // Save the default tenantID back to the document
                await setDoc(docRef, { tenantID: tenantID }, { merge: true });
            }

            const logoRef = doc(db, "tenants", tenantID);
            const logoSnap = await getDoc(logoRef);
            console.log('Tenant Data ', logoSnap.data())
            const logoURL = logoSnap.data().logo;
            const clientAccountId = logoSnap.data().clientAccountId;
            const cash_url = logoSnap.data().cash_url || '';
            console.log('Cash URL', cash_url)
            dispatch({
                type: 'user/setCashURL',
                payload: cash_url
            });

            const collectionRef = collection(db, "tenants", tenantID, "fundraisingTargets");
            console.log('Fetching Fundraising Targets for ', tenantID, "fundraisingTargets")

            const querySnapshot = await getDocs(collectionRef);

            // Process each document


            let fundraisingTargetIDs = [];

            // Process each document
            querySnapshot.forEach((doc) => {
                console.log(`${doc.id} => ${JSON.stringify(doc.data())}`);
                fundraisingTargetIDs.push({
                    id: doc.id,
                    name: doc.data().name,
                    shortURL: doc.data().shortURL,
                    cause: doc.data()?.cause === true,
                    code: doc.data()?.code,
                    cash_url: doc.data()?.cash_url
                }); // Add the document ID to the array
            });

            fundraisingTargetIDs = reorderTargets(fundraisingTargetIDs);

            const payload = { tenantID: tenantID, fundraisingTargets: fundraisingTargetIDs };

            await dispatch(fetchReadersForConnectedAccount(clientAccountId));

            await dispatch({
                type: 'user/setUserRole',
                payload: userRole
            });

            await dispatch({
                type: 'user/setTenantID',
                payload: payload
            });

            await dispatch({
                type: 'user/setLogoURL',
                payload: logoURL
            });

            await dispatch({
                type: 'user/setClientAccountId',
                payload: clientAccountId
            });


            dispatch({
                type: 'app/setReady',
                payload: true
            });

        } else {
            console.log("No such document!");
        }
    };
};

export const checkPOSStatusAction = () => {
    console.log('Checking POS Status')

    return async (dispatch, getState) => {
        const state = getState();
        let terminalId = '';
        dispatch({
            type: 'user/setAwaitingPOSStatusResponse',
            payload: true

        })

        const tenant_id = state.userTenant;
        const docRef = doc(db, "tenants", tenant_id);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            console.log('Found tenant info in Firestore:', docSnap.data());
            terminalId = docSnap.data().terminalId;
        } else {
            return { status: "Error", message: "Tenant info not found in Firestore" };
        }

        const functions = getFunctions();
        const checkPOSStatus = httpsCallable(functions, 'checkPOSStatus');

        try {
            const result = await checkPOSStatus({ terminalId: terminalId });
            console.log('POS Status:', result.data);
            dispatch({
                type: 'user/setPOSstatus',
                payload: result.data
            });

        } catch (error) {
            console.error('Error calling stripe POS Status:', error);
        }
    };
};

export const addReaderToConnectedAccountIfNeeded = (readerCode, clientAccountId) => {
    return async (dispatch, getState) => {
        dispatch({
            type: 'user/setAwaitingReaderResponse',
            payload: true
        });

        const functions = getFunctions();
        const addReader = httpsCallable(functions, 'AddReaderToConnectedAccountIfNeeded');

        const result = await addReader({ clientAccountId: clientAccountId, readerCode: readerCode });
        console.log('Reader added:', result.data);
        dispatch({
            type: 'user/setReaders',
            payload: result.data.readers
        });
        dispatch({
            type: 'user/setAwaitingReaderResponse',
            payload: false
        });


    };


}

export const startListeningToUserLogs = (userId) => {
    return (dispatch) => {
        const logsRef = collection(db, "allowedUsers", userId, "logs");
        const oneDayAgo = new Date(Date.now() - 24 * 60 * 60 * 1000);
        const q = query(logsRef, where("timestamp", ">=", oneDayAgo));

        // Return the unsubscribe function
        return onSnapshot(q, (snapshot) => {
            const logs = [];
            snapshot.forEach((doc) => {
                const timestamp = doc.data().timestamp;
                const date = timestamp?.toDate ? timestamp.toDate() : new Date(timestamp);

                logs.push({
                    id: doc.id,
                    ...doc.data(),
                    timestamp: date
                });
            });

            // Sort logs in reverse chronological order
            logs.sort((a, b) => b.timestamp - a.timestamp);

            dispatch({
                type: 'user/setUserLogs',
                payload: logs
            });
        });
    };
};

export const addTenant = (tenant) => {
    return async (dispatch) => {
        console.log('Adding Tenant', tenant)
        try {
            const docRef = doc(db, "tenants", tenant.tenantID);
            await setDoc(docRef, {
                tenantName: tenant.name || '',
                logo: tenant.logo || '',
                org_id: tenant.orgID || '',
                clientAccountId: tenant.clientAccountId || '',
                cash_url: tenant.cash_url || 'https://paymentfunctions-uploadcampaigncauseprojecttransa-lsxnwb2pga-uc.a.run.app/',
                defaultTarget: tenant.defaultTarget || 'lKWHLGcx1j4LoGVjqRJR',
                defaultTargetId: tenant.defaultTargetId || 'lKWHLGcx1j4LoGVjqRJR',
                fixedRate: tenant.fixedRate !== undefined ? tenant.fixedRate : 1.3,
                variablePercentage: tenant.variablePercentage !== undefined ? tenant.variablePercentage : 2.3,
                terminalId: tenant.terminalId || '123',
                amt1: tenant.amt1 !== undefined ? tenant.amt1 : 10,
                amt2: tenant.amt2 !== undefined ? tenant.amt2 : 20,
                amt3: tenant.amt3 !== undefined ? tenant.amt3 : 50,
                amt4: tenant.amt4 !== undefined ? tenant.amt4 : 100,
                locationsCreated: false,
                CCY: tenant.CCY || 'CAD',
                Band1MinAmt: tenant.Band1MinAmt !== undefined ? tenant.Band1MinAmt : 5,
                Band1MaxAmt: tenant.Band1MaxAmt !== undefined ? tenant.Band1MaxAmt : 9.99,
                Band1Fixed: tenant.Band1Fixed !== undefined ? tenant.Band1Fixed : 0,
                Band1Variable: tenant.Band1Variable !== undefined ? tenant.Band1Variable : 1,
                Band2MinAmt: tenant.Band2MinAmt !== undefined ? tenant.Band2MinAmt : 10,
                Band2MaxAmt: tenant.Band2MaxAmt !== undefined ? tenant.Band2MaxAmt : 99.99,
                Band2Fixed: tenant.Band2Fixed !== undefined ? tenant.Band2Fixed : 1,
                Band2Variable: tenant.Band2Variable !== undefined ? tenant.Band2Variable : 0,
                Band3MinAmt: tenant.Band3MinAmt !== undefined ? tenant.Band3MinAmt : 100,
                Band3MaxAmt: tenant.Band3MaxAmt !== undefined ? tenant.Band3MaxAmt : 100000,
                Band3Fixed: tenant.Band3Fixed !== undefined ? tenant.Band3Fixed : 0,
                Band3Variable: tenant.Band3Variable !== undefined ? tenant.Band3Variable : 1
            });
            console.log("Tenant added with ID: ", tenant.tenantID);
            dispatch(fetchTenants()); // Reload the list of tenants
        } catch (e) {
            console.error("Error adding tenant: ", e);
        }
    };
};

export const fetchTenants = () => {
    return async (dispatch) => {
        console.log('Fetching Tenants')
        try {
            const querySnapshot = await getDocs(collection(db, "tenants"));
            const tenants = [];
            querySnapshot.forEach((doc) => {
                console.log('Tenant:', doc.id)
                tenants.push({
                    ...doc.data(),
                    id: doc.id  // Always override with document ID to ensure it's always set
                });
            });
            dispatch({
                type: 'user/setTenants',
                payload: tenants
            });
        } catch (error) {
            console.error("Error fetching tenants:", error);
        }
    };
};

export const changeTenant = (tenantId) => {
    return async (dispatch, getState) => {
        try {
            const state = getState();
            const userEmail = state.userDetails.email;

            // Update the user's tenantID in Firestore
            const userRef = doc(db, "allowedUsers", userEmail);
            await setDoc(userRef, { tenantID: tenantId }, { merge: true });

            console.log('Successfully updated tenant ID to:', tenantId);

            // Redirect to home page and reload
            window.location.href = '/';

        } catch (error) {
            console.error("Error changing tenant:", error);
        }
    };
};

export const refreshTargets = (tenantID) => {
    return async (dispatch, getState) => {



        console.log('Refreshing targets for tenant:', tenantID);

        const functions = getFunctions();
        const refreshTargetsFunction = httpsCallable(functions, 'refreshTargets');

        try {
            const result = await refreshTargetsFunction({ tenantID: tenantID });
            console.log('Refresh targets result:', result.data);


        } catch (error) {
            console.error('Error calling refresh targets:', error);
            return null;
        }

    }
}

export const clearPaymentSuccess = () => ({
    type: 'payment/clearSuccess'
});

export const fetchCompletedPayments = (tenantId) => {
    return async (dispatch) => {
        dispatch({ type: 'payments/setLoading', payload: true });

        try {
            const paymentsRef = collection(db, 'tenants', tenantId, 'completedPayments');
            const querySnapshot = await getDocs(paymentsRef);

            const payments = [];
            querySnapshot.forEach((doc) => {
                const data = doc.data();
                // Convert Firestore Timestamp to JavaScript Date
                const timestamp = data.timestamp?.toDate();

                payments.push({
                    id: doc.id,
                    ...data
                });
            });

            // Sort payments by timestamp in descending order (newest first)
            payments.sort((a, b) => b.timestamp - a.timestamp);

            dispatch({
                type: 'payments/setCompletedPayments',
                payload: payments
            });
        } catch (error) {
            console.error('Error fetching completed payments:', error);
        } finally {
            dispatch({ type: 'payments/setLoading', payload: false });
        }
    };
};

export const startListeningToCompletedPayments = (tenantId) => {
    return (dispatch) => {
        const paymentsRef = collection(db, "tenants", tenantId, "completedPayments");
        const q = query(paymentsRef, orderBy("timestamp", "desc"), limit(200));

        // Return the unsubscribe function
        return onSnapshot(q, (snapshot) => {
            const payments = [];
            snapshot.forEach((doc) => {
                payments.push({
                    id: doc.id,
                    ...doc.data(),
                    timestamp: doc.data().timestamp?.toDate(),
                    _firestoreTimestamp: doc.data().timestamp
                });
            });

            dispatch({ type: 'payments/setCompletedPayments', payload: payments });
            dispatch({ type: 'payments/setHasMore', payload: payments.length >= 200 });
        });
    };
};

export const loadMoreCompletedPayments = (tenantId) => {
    return async (dispatch, getState) => {
        const { completedPayments } = getState();
        if (!completedPayments.length) return;

        const lastPayment = completedPayments[completedPayments.length - 1];
        if (!lastPayment._firestoreTimestamp) return;

        dispatch({ type: 'payments/setLoading', payload: true });

        const paymentsRef = collection(db, "tenants", tenantId, "completedPayments");
        const q = query(
            paymentsRef,
            orderBy("timestamp", "desc"),
            startAfter(lastPayment._firestoreTimestamp),
            limit(200)
        );

        const snapshot = await getDocs(q);
        const payments = [];
        snapshot.forEach((doc) => {
            payments.push({
                id: doc.id,
                ...doc.data(),
                timestamp: doc.data().timestamp?.toDate(),
                _firestoreTimestamp: doc.data().timestamp
            });
        });

        dispatch({ type: 'payments/appendCompletedPayments', payload: payments });
        dispatch({ type: 'payments/setHasMore', payload: payments.length >= 200 });
        dispatch({ type: 'payments/setLoading', payload: false });
    };
};

export const getToken = (clientAccountId) => {
    return async (dispatch) => {
        try {
            const functions = getFunctions();
            const getTokenFunction = httpsCallable(functions, 'getToken');
            const result = await getTokenFunction({ connectedAccountID: clientAccountId });

            if (result.data.status === 'Success') {
                dispatch({
                    type: 'user/setSecretToken',
                    payload: result.data.connectionToken.secret
                });
            } else {
                console.error('Error getting token:', result.data.error);
            }
        } catch (error) {
            console.error('Error calling getToken function:', error);
        }
    };
};

export const uploadFileToStripe = (file) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: 'file/setUploadInProgress', payload: true });
            const state = getState();
            const token = state.secretToken;

            const formData = new FormData();
            formData.append('file', file);
            formData.append('purpose', 'terminal_reader_splashscreen');
            let response;
            console.log('Uploading file to Stripe with token:', token, ' and clientAccountId:', state.clientAccountId)
            try {
                response = await fetch('https://files.stripe.com/v1/files', {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Stripe-Account': state.clientAccountId

                    },
                    body: formData
                });
            } catch (error) {
                console.error('Error during file upload to Stripe:', error.message, error.stack);
            }

            const result = await response.json();

            if (result.id) {
                const tenantRef = doc(db, "tenants", state.userTenant);
                await setDoc(tenantRef, {
                    splashScreenImageFile: result.id
                }, { merge: true });
            }
        } catch (error) {
            console.error('Error uploading file:', error);
        } finally {
            dispatch({ type: 'file/setUploadInProgress', payload: false });
        }
    };
};

export const setSelectedTargetCode = (code) => ({
    type: 'user/setSelectedTargetCode',
    payload: code
});

export const updateTenant = (tenantId, updates) => {
    return async (dispatch) => {
        try {
            const docRef = doc(db, "tenants", tenantId);
            await setDoc(docRef, updates, { merge: true });
            console.log("Tenant updated successfully");
            dispatch(fetchTenants()); // Refresh the tenants list
        } catch (error) {
            console.error("Error updating tenant:", error);
        }
    };
};

export const addFundraisingTarget = (tenantId, targetData) => {
    return async (dispatch) => {
        try {
            const targetRef = doc(db, "tenants", tenantId, "fundraisingTargets", targetData.id);
            await setDoc(targetRef, {
                name: targetData.name,
                code: targetData.code,
                cause: targetData.cause,
                shortURL: targetData.shortURL
            });
            console.log("Fundraising target added successfully");
            return true;
        } catch (error) {
            console.error("Error adding fundraising target:", error);
            return false;
        }
    };
};

export const addUser = (email, tenantId = null, role = 'user') => {
    return async (dispatch, getState) => {
        try {
            const state = getState();
            // Use provided tenantId or fall back to current user's tenant
            const tenantID = tenantId || state.userTenant;

            if (!tenantID) {
                console.error("Error adding user: No tenant ID provided");
                return false;
            }

            // Validate role - only allow valid roles
            const validRoles = ['user', 'tenant-admin', 'admin'];
            const userRole = validRoles.includes(role) ? role : 'user';

            // Add user to allowedUsers collection
            const userRef = doc(db, "allowedUsers", email.toLowerCase());
            await setDoc(userRef, {
                tenantID: tenantID,
                role: userRole
            });

            // Refresh the users list
            dispatch(fetchAllowedUsers(tenantID));

            return true;
        } catch (error) {
            console.error("Error adding user:", error);
            return false;
        }
    };
};

export const deleteUser = (userEmail) => {
    return async (dispatch, getState) => {
        try {
            const userRef = doc(db, "allowedUsers", userEmail.toLowerCase());
            await deleteDoc(userRef);
            
            // Refresh the users list
            const state = getState();
            dispatch(fetchAllowedUsers());
            
            return true;
        } catch (error) {
            console.error("Error deleting user:", error);
            return false;
        }
    };
};

export const deleteUsers = (userEmails) => {
    return async (dispatch, getState) => {
        try {
            const deletePromises = userEmails.map(email => {
                const userRef = doc(db, "allowedUsers", email.toLowerCase());
                return deleteDoc(userRef);
            });
            
            await Promise.all(deletePromises);
            
            // Refresh the users list
            const state = getState();
            dispatch(fetchAllowedUsers());
            
            return true;
        } catch (error) {
            console.error("Error deleting users:", error);
            return false;
        }
    };
};

export const updateUserRole = (userEmail, newRole) => {
    return async (dispatch, getState) => {
        try {
            const userRef = doc(db, "allowedUsers", userEmail.toLowerCase());
            
            // First, get the current user document to preserve tenantID
            const userSnap = await getDoc(userRef);
            const updateData = { role: newRole };
            
            // Preserve tenantID if it exists
            if (userSnap.exists() && userSnap.data().tenantID) {
                updateData.tenantID = userSnap.data().tenantID;
            }
            
            await setDoc(userRef, updateData, { merge: true });
            
            // Refresh the users list
            const state = getState();
            dispatch(fetchAllowedUsers(state.userTenant));
            
            return true;
        } catch (error) {
            console.error("Error updating user role:", error);
            return false;
        }
    };
};

export const updateUserTenant = (userEmail, newTenantId) => {
    return async (dispatch, getState) => {
        try {
            const userRef = doc(db, "allowedUsers", userEmail.toLowerCase());
            await setDoc(userRef, { tenantID: newTenantId }, { merge: true });
            
            // Refresh the users list
            dispatch(fetchAllowedUsers());
            
            return true;
        } catch (error) {
            console.error("Error updating user tenant:", error);
            return false;
        }
    };
};

export const processCashPayment = (details) => {
    return async (dispatch, getState) => {
        if (!details.email) {
            alert('Email is required for cash donations');
            return;
        }

        if (!details.name) {
            alert('Name is required for cash donations');
            return;
        }

        dispatch({ type: 'payment/setAwaitingCash', payload: true });

        const state = getState();
        const cash_url = state.cash_url;
        const selectedTarget = state.fundraisingTargets[state.selectedFundraisingTarget];
        const selectedTargetCode = state.selectedTargetCode;
        const email = details.email;
        const amount = parseFloat(details.amount.replace(/[$,]/g, ''));

        const today = new Date();
        const formattedDate = today.toISOString().split('T')[0].replace(/-/g, '/');

        const payload = {
            data: [{
                email: email,
                linked_fundraiser: selectedTargetCode,
                name: details.name,
                transaction_amount: amount,
                transaction_channel: "cash",
                transaction_date: formattedDate,
                transaction_tags: ""
            }]
        };

        console.log('Sending Cash Payment to', cash_url)
        console.log('Payload', payload)

        try {
            const response = await fetch(cash_url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                dispatch({
                    type: 'payment/setSuccess',
                    payload: {
                        status: "Cash payment recorded",
                        amount: amount,
                        email: email
                    }
                });
            }
        } catch (error) {
            console.error('Error processing cash payment:', error);
        } finally {
            dispatch({ type: 'payment/setAwaitingCash', payload: false });
        }
    }
};

export const signUpWithEmailPassword = (email, password) => {
    return async (dispatch) => {
        try {
            // First create the user account


            const userCredential = await createUserWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;

            try {
                // Then check if they're in allowedUsers
                const docRef = doc(db, "allowedUsers", user.email.toLowerCase());
                const docSnap = await getDoc(docRef);
            } catch (error) {
                console.error("Error in signUpWithEmailPassword:", error);
                await auth.signOut();
                return { success: false, error: error.message };
            }



            dispatch({
                type: 'user/signIn',
                payload: {
                    uid: user.uid,
                    email: user.email
                }
            });

            return { success: true };
        } catch (error) {
            console.error("Error in signUpWithEmailPassword:", error);
            return { success: false, error: error.message };
        }
    };
};

export const signInWithEmailPassword = (email, password) => {
    return async (dispatch) => {
        try {
            // Check if email exists in allowedUsers

            const userCredential = await signInWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;

            try {
                // Then check if they're in allowedUsers
                const docRef = doc(db, "allowedUsers", user.email.toLowerCase());
                const docSnap = await getDoc(docRef);
            } catch (error) {
                console.error("Error in signInWithEmailPassword:", error);
                await auth.signOut();
                return { success: false, error: error.message };
            }

            dispatch({
                type: 'user/signIn',
                payload: {
                    uid: user.uid,
                    email: user.email
                }
            });

            return { success: true };
        } catch (error) {
            console.error("Error in signInWithEmailPassword:", error);
            return { success: false, error: error.message };
        }
    };
};

export const resetPassword = (email) => {
    return async (dispatch) => {
        try {
            await sendPasswordResetEmail(auth, email);
            return { success: true };
        } catch (error) {
            console.error("Error sending password reset email:", error);
            return { success: false, error: error.message };
        }
    };
};

export const resetUserPasswordByAdmin = (userEmail, newPassword) => {
    return async (dispatch, getState) => {
        try {
            const functions = getFunctions();
            const resetUserPassword = httpsCallable(functions, 'resetUserPassword');

            const result = await resetUserPassword({ userEmail, newPassword });

            if (result.data.status === 'Success') {
                return {
                    success: true,
                    message: result.data.message
                };
            } else {
                return {
                    success: false,
                    error: result.data.error || 'Failed to reset password'
                };
            }
        } catch (error) {
            console.error("Error resetting user password:", error);
            return {
                success: false,
                error: error.message || 'Failed to reset password'
            };
        }
    };
};

// ============================================
// POS Admin Actions
// ============================================

// Helper function to get bearer token for API calls
const getApiToken = async () => {
    const settingsDoc = await getDoc(doc(db, 'settings', 'onRequest'));
    if (!settingsDoc.exists()) {
        throw new Error('API settings not found');
    }
    return settingsDoc.data().token;
};

// Base URL for S700 API functions
const S700_API_BASE = 'https://us-central1-stripepos-infaque.cloudfunctions.net';

// Fetch locations for a tenant
export const fetchPosLocations = (tenantId) => {
    return async (dispatch) => {
        dispatch({ type: 'posAdmin/setLocationsLoading', payload: true });
        try {
            const token = await getApiToken();
            const response = await fetch(
                `${S700_API_BASE}/getLocationsForTenant?tenant-id=${tenantId}`,
                {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );
            const data = await response.json();

            if (data.status === 'Success') {
                dispatch({ type: 'posAdmin/setLocations', payload: data.locations || [] });
                return { success: true, locations: data.locations };
            } else {
                dispatch({ type: 'posAdmin/setError', payload: data.error });
                return { success: false, error: data.error };
            }
        } catch (error) {
            console.error('Error fetching locations:', error);
            dispatch({ type: 'posAdmin/setError', payload: error.message });
            return { success: false, error: error.message };
        }
    };
};

// Add a new location
export const addPosLocation = (tenantId, displayName, address) => {
    return async (dispatch) => {
        try {
            const token = await getApiToken();
            const response = await fetch(
                `${S700_API_BASE}/addLocationToTenant`,
                {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        'tenant-id': tenantId,
                        display_name: displayName,
                        address: address
                    })
                }
            );
            const data = await response.json();

            if (data.status === 'Success') {
                // Refresh locations list
                dispatch(fetchPosLocations(tenantId));
                return { success: true, location: data.location };
            } else {
                return { success: false, error: data.error };
            }
        } catch (error) {
            console.error('Error adding location:', error);
            return { success: false, error: error.message };
        }
    };
};

// Delete a location
export const deletePosLocation = (tenantId, locationId) => {
    return async (dispatch) => {
        try {
            const token = await getApiToken();
            const response = await fetch(
                `${S700_API_BASE}/deleteLocationFromTenant`,
                {
                    method: 'DELETE',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        'tenant-id': tenantId,
                        'location-id': locationId
                    })
                }
            );
            const data = await response.json();

            if (data.status === 'Success') {
                // Refresh locations list
                dispatch(fetchPosLocations(tenantId));
                return { success: true };
            } else {
                return { success: false, error: data.error };
            }
        } catch (error) {
            console.error('Error deleting location:', error);
            return { success: false, error: error.message };
        }
    };
};

// Fetch readers for a tenant (S700 and WisePOS E)
export const fetchPosReaders = (tenantId) => {
    return async (dispatch) => {
        dispatch({ type: 'posAdmin/setReadersLoading', payload: true });
        try {
            const token = await getApiToken();
            const response = await fetch(
                `${S700_API_BASE}/getReadersForTenant?tenant-id=${tenantId}`,
                {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );
            const data = await response.json();

            if (data.status === 'Success') {
                dispatch({ type: 'posAdmin/setReaders', payload: data.readers || [] });
                return { success: true, readers: data.readers };
            } else {
                dispatch({ type: 'posAdmin/setError', payload: data.error });
                return { success: false, error: data.error };
            }
        } catch (error) {
            console.error('Error fetching readers:', error);
            dispatch({ type: 'posAdmin/setError', payload: error.message });
            return { success: false, error: error.message };
        }
    };
};

// Add a new reader
export const addPosReader = (tenantId, registrationCode, label, deviceType = 'stripe_s700') => {
    return async (dispatch) => {
        try {
            const token = await getApiToken();
            const response = await fetch(
                `${S700_API_BASE}/addReaderToTenant`,
                {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        'tenant-id': tenantId,
                        registration_code: registrationCode,
                        reader_label: label,
                        device_type: deviceType
                    })
                }
            );
            const data = await response.json();

            if (data.status === 'Success') {
                // Refresh readers list
                dispatch(fetchPosReaders(tenantId));
                return { success: true, reader: data.reader };
            } else {
                return { success: false, error: data.error };
            }
        } catch (error) {
            console.error('Error adding reader:', error);
            return { success: false, error: error.message };
        }
    };
};

// Remove a reader
export const removePosReader = (tenantId, readerId) => {
    return async (dispatch) => {
        try {
            const token = await getApiToken();
            const response = await fetch(
                `${S700_API_BASE}/removeReaderFromTenant`,
                {
                    method: 'DELETE',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        'tenant-id': tenantId,
                        'reader-id': readerId
                    })
                }
            );
            const data = await response.json();

            if (data.status === 'Success') {
                // Refresh readers list
                dispatch(fetchPosReaders(tenantId));
                return { success: true };
            } else {
                return { success: false, error: data.error };
            }
        } catch (error) {
            console.error('Error removing reader:', error);
            return { success: false, error: error.message };
        }
    };
};

// Fetch all available targets (from local Firestore fundraisingTargets collection)
export const fetchAllTargets = (tenantId) => {
    return async (dispatch) => {
        dispatch({ type: 'posAdmin/setAllTargetsLoading', payload: true });
        try {
            // First get the tenant's default org_id as fallback
            const tenantDocRef = doc(db, "tenants", tenantId);
            const tenantDocSnap = await getDoc(tenantDocRef);
            const tenantOrgId = tenantDocSnap.exists()
                ? (tenantDocSnap.data()?.org_id || tenantDocSnap.data()?.orgID || null)
                : null;

            const collectionRef = collection(db, "tenants", tenantId, "fundraisingTargets");
            const querySnapshot = await getDocs(collectionRef);

            const targets = [];
            querySnapshot.forEach((docSnap) => {
                const data = docSnap.data();
                targets.push({
                    id: docSnap.id,
                    name: data.name,
                    code: data.code,
                    cause: data?.cause === true,
                    shortURL: data?.shortURL,
                    // Use target's orgID, fall back to tenant's org_id
                    orgID: data?.orgID || data?.org_id || tenantOrgId
                });
            });

            // Sort alphabetically by name
            targets.sort((a, b) => a.name.localeCompare(b.name));

            dispatch({ type: 'posAdmin/setAllTargets', payload: targets });
            return { success: true, targets: targets };
        } catch (error) {
            console.error('Error fetching all targets:', error);
            dispatch({ type: 'posAdmin/setError', payload: error.message });
            return { success: false, error: error.message };
        }
    };
};

// Fetch S700 configured targets
export const fetchS700Targets = (tenantId) => {
    return async (dispatch) => {
        dispatch({ type: 'posAdmin/setS700TargetsLoading', payload: true });
        try {
            const token = await getApiToken();
            const response = await fetch(
                `${S700_API_BASE}/getS700Targets?tenant-id=${tenantId}`,
                {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );
            const data = await response.json();

            if (data.status === 'Success') {
                dispatch({ type: 'posAdmin/setS700Targets', payload: data.targets || [] });
                return { success: true, targets: data.targets };
            } else {
                dispatch({ type: 'posAdmin/setError', payload: data.error });
                return { success: false, error: data.error };
            }
        } catch (error) {
            console.error('Error fetching S700 targets:', error);
            dispatch({ type: 'posAdmin/setError', payload: error.message });
            return { success: false, error: error.message };
        }
    };
};

// Set S700 targets (up to 4)
export const saveS700Targets = (tenantId, targets) => {
    return async (dispatch) => {
        try {
            if (targets.length > 4) {
                return { success: false, error: 'Maximum 4 targets allowed' };
            }

            const token = await getApiToken();
            const response = await fetch(
                `${S700_API_BASE}/setS700Targets`,
                {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        'tenant-id': tenantId,
                        targets: targets
                    })
                }
            );
            const data = await response.json();

            if (data.status === 'Success') {
                // Refresh S700 targets list
                dispatch(fetchS700Targets(tenantId));
                return { success: true };
            } else {
                return { success: false, error: data.error };
            }
        } catch (error) {
            console.error('Error saving S700 targets:', error);
            return { success: false, error: error.message };
        }
    };
};

// Fetch reader status (full Stripe response)
export const fetchReaderStatus = (tenantId, readerId) => {
    return async (dispatch) => {
        try {
            const token = await getApiToken();
            const response = await fetch(
                `${S700_API_BASE}/getReaderStatus?tenant-id=${tenantId}&reader-id=${readerId}`,
                {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );
            const data = await response.json();

            if (data.status === 'Success') {
                return { success: true, reader: data.reader };
            } else {
                return { success: false, error: data.error };
            }
        } catch (error) {
            console.error('Error fetching reader status:', error);
            return { success: false, error: error.message };
        }
    };
};

// Start donation flow on a reader
export const startDonationFlow = (tenantId, readerId) => {
    return async (dispatch) => {
        try {
            const token = await getApiToken();
            const response = await fetch(
                `${S700_API_BASE}/collectS700Targets`,
                {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        'tenant-id': tenantId,
                        'reader_id': readerId
                    })
                }
            );
            const data = await response.json();

            if (data.status === 'Success') {
                return { success: true, message: data.message, session_id: data.session_id };
            } else {
                return { success: false, error: data.error };
            }
        } catch (error) {
            console.error('Error starting donation flow:', error);
            return { success: false, error: error.message };
        }
    };
};

// Clear POS admin error
export const clearPosAdminError = () => ({
    type: 'posAdmin/clearError'
});